/** @jsxImportSource @emotion/react */
import { Autocomplete, Table, TableBody, TableRow, TableCell, OutlinedInput, Button, Link, Checkbox, FormControl, FormControlLabel, FormHelperText, Grid, InputLabel, MenuItem, Radio, RadioGroup, Select, Snackbar, ToggleButton, ToggleButtonGroup, Typography, useMediaQuery, useTheme, Divider, DialogContent, DialogActions, List, ListItem, ListItemText, TableHead, TextField } from '@mui/material';
import { useFormik } from 'formik';
import { useContext, useState } from 'react';
import ElevatedGrid from '../../Components/ElevatedGrid';
import { Il8nContext } from '../../Helper/i18n';
import PageLayout from '../Layout/PageLayout';
import * as yup from 'yup';
import { useEffect } from 'react';
import { StyledTextField } from '../../Components/CustomTextfield';
import MySnackbarContentWrapper from '../../Components/Snackbars';
import config from '../../config';
import axios from '../../Helper/Axios/interceptor';
import { useDispatch, useSelector } from 'react-redux';
import { addStageData, updateStepper } from '../../Helper/Redux/reducers/upDown';
import FullScreenLoader from '../../Components/FullScreenLoader';
import { useNavigate } from 'react-router-dom';
import UploadIcon from "../../Components/DocumentUpload/UploadIcon"
import DialogForUpload from "../../Components/DocumentUpload/DialogForUpload"
import UploadDialog from "../../Components/DocumentUpload/UploadDialog"
import UploadPdf from "../../Components/DocumentUpload/UploadPdf"
import ProofDialog from "../../Components/DocumentUpload/ProofDialog"
import { detailChecker, steps, getGlobalSteper } from '../../Helper/AppStepperData';
import Popup, { PopupTitle } from '../../Components/CustomPopup';
import CloseIcon from '@mui/icons-material/Close';
import { getObjections, objectionNavigation, setObjections } from '../../Helper/Functions';
import Upload from '../../Components/Upload';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import ConsentAgreementSection from '../../Components/ConsentAgreementSection';
import { MTFConsentDataForClient, MTFConsentDataForClientObligations, MTFConsentDataForClientRights, MTFConsentForStockBrokerObligations, MTFConsentForStockBrokerRights, MTFConsentForTerminationOfRelation, MTFConsentForTermsofTBAnswer, MTFConsentMarginTradingQuestions } from '../AddressTermsAndConditions';

var stageStatus;
var kraVerified;
const initialConsentCheckBox = {"creditPledgeInstruction": true,
    "electronicContractNoteNstatement": true,
    "shareEmailWithRegistrarNrta": true,
    "dividendInterestinBankAc": true,
    "internetTrading": true,
    "electronicAnnualReport": true,
    "rightObligation": true,
    "receiveDisslip": false,
    "dpAccountStatement": "As per SEBI Regulations",
    "casFlag": true,
    "pastAction": false,
    "pastActionReason":"",
    "casMode": "eCAS",
    "preferredDepository": "CDSL",
    "authRunningAccount": "Quarterly"
}

const initialDdpiConsentCheckBox = {
    "transferOfSecurities": true,
    "pledgingRepledgingOfSecurities": true,
    "mutualFundTransactions": true,
    "tenderingSharesInOpenOffers": true
}

function AddressDetails(props) {
    const theme = useTheme();
    const store = useSelector(state => state.storeState.stage)
    const stepper = useSelector(state => state.storeState.stepper)
    const dispatch = useDispatch()
    const [snackBarOpen, setSnackBarOpen] = useState(false)
    const [responseStatus, setResponseStatus] = useState({})
    const [options, setOptions] = useState()
    const [pincodeOptions, setPincodeOptions] = useState([])
    const [loading, setLoading] = useState(false)
    const [open, setOpen] = useState({ corr: false, perm: false });
    const [consentOpen, setConsentOpen] = useState(false);
    const [mitcConsentOpen, setMitcConsentOpen] = useState(false)
    const [mtfConsentOpen, setMtfConsentOpen] = useState(false)
    const [ddpiConsentOpen, setDdpiConsentOpen] = useState(false)
    const [isConsentSatisfied, setIsConsentSatisfied] = useState(false)
    const [isDDPIConsentSatisfied, setIsDDPIConsentSatisfied] = useState(false)
    const [ocrUploadLoading,setOcrUploadLoading] = useState(false)
    const navigate = useNavigate()

    const [id, setId] = useState();
    const [isEdit, setIsEdit] = useState(false)
    const [kRAData, setKRAData] = useState({})
    const [FATCAData, setFATCAData] = useState()
    const [openKRAVerifiedDataPopup, setOpenKRAVerifiedDataPopup] = useState(false)
    const [objectionState, setObjectionState] = useState({ "isObjection": false, "objections": [] })

    const [documentsUploadedDetails, setDocumentsUploadedDetails] = useState([])
    const [documentOf, setDocumentOf] = useState()
    const [documentOfScreen, setDocumentOfScreen] = useState()
    const [openInnerDialog, setOpenInnerDialog] = useState(false);
    const [documentTypeOption, setDocumentTypeOption] = useState();
    const [documentUploadedFor, setDocumentUploadedFor] = useState();
    const [showUploadPopup, setUploadPopup] = useState(false);
    const [image, setImage] = useState();
    const [pdf, setPdf] = useState();
    const [showPdfPopup, setPdfPopup] = useState(false);
    const [docMId, setDocMId] = useState()
    const [numberOfImages, setNumberOfImages] = useState(1)
    const [documentName, setDocumentName] = useState("");
    const [documentMappingKey, setDocumentMappingKey] = useState("");
    const [uploadedDocuments, setUploadedDocuments] = useState({ cpoa: [], ppoa: [] });
    const [showFields, setShowFields] = useState({ CPOA: false, PPOA: false, CPOAdisabled: false, PPOAdisabled: false })
    const localeText = useContext(Il8nContext)
    const [checkedField, setCheckedField] = useState(initialConsentCheckBox)
    const [isDdpiCheckedField, setisDdpiCheckedField] = useState(initialDdpiConsentCheckBox)
    const [aINxDocumentFailedPopup, setAINxDocumentFailedPopup] = useState(false)
    const [stageDetailsData,setStageDetailsData] = useState(null)

    const documentTypePerName = {
        "CPOA": "Corresponding Address",
        "PPOA": "Permanent Address",
        "POA": "Power of Attorney",
        "POI": "Proof Of Identity",
        "Sign": "Signature",
        "Photo": "Photograph",
        "KYCP": "KYC Proof",
        "DePr": "Demat Proof",
        "BaPr": "Bank Proof",
        "InPr": "Income Proof",
        "Nom": "Nominee Proof",
        "Gurd": "Guardian Proof",
        "IPV": "In-Person Verification",
        "KRA": "KYC KRA Page",
        "default": "Document Upload",
        "BalSh": "Copy of Balance sheet of past two years",
        "AuSig": "Authorised Signatory on letter head of Firm/Company",
        "ITR": "IT Return for last 2 financial years",
        "PDeed": "Partnership  deed",
        "PCapR": "Partnership capital ratio",
        "DMapL": "Demat account Mapping Letter",
        "MOA": "MOA and AOA of the company",
        "Annx": "Annexure page",
        "BoRes": "Board Resolution",
        "NetWo": "Net Worth Certificate",
        "RCert": "Registration Certificate",
        "Oth": "Others",
    }

    const documentICONS = {
        "CPOA": "/images/Address Proof.svg",
        "PPOA": "/images/Address Proof.svg",
        "POI": "/images/Photo ID Proof.svg",
        "Sign": "/images/Signature.svg",
        "Photo": "/images/Photo.svg",
        "BaPr": "/images/Bank-Proof.svg",
        "IPV": "/images/IPV (Video Recording).svg",
        "Oth": "/images/Signature.svg"
    }

    const MITCContentData=[
        {instruction:localeText?.consentAddressInstr1},
        {instruction:localeText?.consentAddressInstr2},
        {instruction:localeText?.consentAddressInstr3},
        {instruction:localeText?.consentAddressInstr4},
        {instruction:localeText?.consentAddressInstr5},
        {instruction:localeText?.consentAddressInstr6},
        {instruction:localeText?.consentAddressInstr7},
        {instruction:localeText?.consentAddressInstr8},
        {instruction:localeText?.consentAddressInstr9},
        {instruction:localeText?.consentAddressInstr10},
    ]

    const getLastDateOfFinancialYear = () => {
        const currentMonth = new Date().getMonth();
        const networthDate = new Date(currentMonth>2 ? (new Date().getFullYear()) : (new Date().getFullYear()-1), 2, 31).getTime();
        return networthDate
    };

    useEffect(() => {
        getFATCAOptions()
        getStageDetails()
        let objectionValue = getObjections()
        let objections = objectionValue?.filter(objection => objection.navigationPath == "/AddressDetails")

        if (objections?.length > 0) {
            objections = objections.map(objection => {
                return {
                    "objectionDescription": objection.objectionDescription,
                    "remark": objection.remark
                }
            })

            objectionValue = objectionValue.map(objection => {
                if (objection.navigationPath == "/AddressDetails") {
                    objection.isNavigationDone = true;
                }
                return objection
            })

            setObjections(objectionValue)
            setObjectionState({ isObjection: true, objections })
        }
    }, [])


    useEffect(() => {
        getAllAdressData()
    }, [uploadedDocuments])

    useEffect(() => {
        const ignoreConsent = ["authRunningAccount"]
        var tempinitalConsent = {...initialConsentCheckBox}
        var tempcheckfield = {...checkedField}
        ignoreConsent.map(consent =>{
            delete tempinitalConsent[consent]
            delete tempcheckfield[consent]
        })
        setIsConsentSatisfied(JSON.stringify(tempcheckfield) != JSON.stringify(tempinitalConsent))
    }, [checkedField])

    useEffect(() => {
        var tempinitalConsent = {...initialDdpiConsentCheckBox}
        var tempcheckfield = {...isDdpiCheckedField}
        setIsDDPIConsentSatisfied(JSON.stringify(tempcheckfield) != JSON.stringify(tempinitalConsent))
    }, [isDdpiCheckedField])

    const getAllAdressData = (uploadedDoc) =>{
        let fields = { ...showFields };
        if (Object.keys(uploadedDocuments)?.length > 0 || Object.keys(uploadedDoc)?.length > 0) {
            let cpoaDocs = uploadedDoc || uploadedDocuments || []
            if (cpoaDocs?.cpoa?.length > 0) {
                let CPOAData = cpoaDocs?.cpoa?.filter(item => {
                    if (item?.ocrDetails?.address_pin) {
                        return item.ocrDetails
                    }
                })
                if(CPOAData?.length > 0 && Object.keys(CPOAData[0]?.ocrDetails)?.length > 0){
                    fields.CPOA = true
                    fields.PPOA = true
                }
                CPOAData?.length > 0 && getAllOCRDetails(CPOAData[0]?.ocrDetails || {}, 'cpoa')
                CPOAData?.length > 0 && getAllOCRDetails(CPOAData[0]?.ocrDetails || {}, 'ppoa')
            } else if (cpoaDocs?.cpoa?.length === 0 && stageStatus?.status == 0 || cpoaDocs?.ppoa?.length === 0 && stageStatus?.status == 0) {
                fields.CPOA = false
                fields.PPOA = false
            }
            setShowFields({ ...fields })
        } else {
            setShowFields({ CPOA: false, PPOA: false, PPOAdisabled: false, CPOAdisabled: false })
        }
    }

    const getAllOCRDetails = (values, type) => {
        const { address, address_pin, pincode, address_care_of, address_house_number, address_line1, address_line2, address_landmark } = values || {};
        let combinedAddress = '';
        if (address) {
            combinedAddress = address;
        } else {
            combinedAddress = [ address_care_of, address_house_number, address_line1, address_line2, address_landmark ]?.filter(part => part && part?.trim() !== '')?.join(' ');
        }
        const addressParts = combinedAddress?.replace(/,+/g, ' ')?.trim()?.split(/\s+/)?.filter(part => part);
        const totalWords = addressParts?.length;
        let flatHouseNo = '';
        let colonyStreetLocality = '';
        let townArea = '';
        if (totalWords <= 3) {
            flatHouseNo = addressParts?.slice(0, 1)?.join(' ');
            colonyStreetLocality = addressParts?.slice(1, 2)?.join(' ');
            townArea = addressParts?.slice(2)?.join(' ');
        } else {
            const baseCount = Math.floor(totalWords / 3);
            const remainder = totalWords % 3;

            const counts = [baseCount, baseCount, baseCount];
            for (let i = 0; i < remainder; i++) {
                counts[i]++;
            }
            let index = 0;
            flatHouseNo = addressParts?.slice(index, index + counts[0]).join(' ');
            index += counts[0];
            colonyStreetLocality = addressParts?.slice(index, index + counts[1]).join(' ');
            index += counts[1];
            townArea = addressParts?.slice(index, index + counts[2]).join(' ');
        }
        const truncateField = (field) => field?.length > 100 ? field?.substring(0, 100) : field;
        flatHouseNo = truncateField(flatHouseNo);
        colonyStreetLocality = truncateField(colonyStreetLocality);
        townArea = truncateField(townArea);
        if (type === 'cpoa') {
            if (address_pin || pincode) {
                autoPincodeSearch((address_pin || pincode)?.trim(), type);
            }
            formik.setFieldValue('corrFlatHouseNo', flatHouseNo);
            formik.setFieldValue('corrColonyStreetLocality', colonyStreetLocality);
            formik.setFieldValue('corrTownArea', townArea);
        } else if (type === 'ppoa') {
            formik.setFieldValue('permFlatHouseNo', flatHouseNo);
            formik.setFieldValue('permColonyStreetLocality', colonyStreetLocality);
            formik.setFieldValue('permTownArea', townArea);
            if (address_pin || pincode) {
                autoPincodeSearch((address_pin || pincode)?.trim(), type);
            }
        }
    };

    const getStageDetails = () => {
        setLoading(true)
        axios.get(process.env.REACT_APP_API_URL + config.stageDetails)
            .then(resp => {
                if (resp.data.success) {
                    stageStatus = resp.data.success.stageDetilasList[0];
                    setStageDetailsData(resp?.data?.success)
                    !(stepper?.length) && dispatch(updateStepper(getGlobalSteper(resp.data.success.stageDetilasList)))
                    if (detailChecker(resp.data.success.stageDetilasList, 0)) {
                        getAddressDetails()
                    }
                    else {
                        getKRADetails()
                        setUploadedDocuments({...uploadedDocuments,docChecked:true})
                    }
                    if (detailChecker(resp.data.success.stageDetilasList, 1)) {
                        getFATCADetails()
                    }
                } else {
                    throw new Error()
                }
            }).catch((err) => {
                setLoading(false)
                console.log(err.message)
            })
    }


    const initialAddressDetailsValues = (values = kRAData, isEdited) => {
        // ["fName","mName","lName","faFName","fmFName","flFName","gender","marStatus","email","mobile","emailRelation","mobileRelation"]
        formik.setFieldValue("corrFlatHouseNo", values?.corrAddress1 || values?.corAddress1)
        formik.setFieldValue("corrColonyStreetLocality", values?.corrAddress2 || values?.corAddress2)
        formik.setFieldValue("corrTownArea", values?.corrAddress3 || values?.corAddress3)
        formik.setFieldValue("corrLandmark", values?.corrLandMark)
        formik.setFieldValue("corrPincode", values?.corrAddressPincode || values?.corPin)
        formik.setFieldValue("corrState", values?.corrAddressState || values?.corState)
        formik.setFieldValue("corrCity", values?.corrAddressCity || values?.corCity)
        !isEdited && formik.setFieldValue("sameAsCorrAddress", values?.sameAsCorrespondanceAddress || "")
        formik.setFieldValue("permFlatHouseNo", values?.permAddress1 || values?.perAddress1 || "")
        formik.setFieldValue("permColonyStreetLocality", values?.permAddress2 || values?.perAddress2 || "")
        formik.setFieldValue("permTownArea", values?.permAddress3 || values?.perAddress3 || "")
        formik.setFieldValue("permLandmark", values?.permLandMark || "")
        formik.setFieldValue("permPincode", values?.permAddressPinCode || values?.perPin || "")
        formik.setFieldValue("permState", values?.permAddressState || values?.perState || "")
        formik.setFieldValue("permCity", values?.permAddressCity || values?.perCity || "")
    }

    const initialFATCADetailsValues = (values = FATCAData) => {
        // ["fName","mName","lName","faFName","fmFName","flFName","gender","marStatus","email","mobile","emailRelation","mobileRelation"]
        formik.setFieldValue("annualIncomeRange", values.incomeSlabId)
        formik.setFieldValue("networth", values.networth )
        formik.setFieldValue("networthDate", values.networthDate|| getLastDateOfFinancialYear())
        formik.setFieldValue("occupation", values.occupationId)
        formik.setFieldValue("tradingExp", values.tradingExperience)
        formik.setFieldValue("politicalAffiliation", values.politicallyExpPerson)
        formik.setFieldValue("natureOfBusiness", values.natureOfBusinessId)
        formik.setFieldValue("natureOfBusinessOther", values.natureOfBusinessOther)
        formik.setFieldValue("sourceOfWealth", values.sourceOfWealth)
        formik.setFieldValue("placeOfBirth", values.placeOfBirth)
        formik.setFieldValue("countryOfBirth", values.countryOfBirth)
        formik.setFieldValue("isFatca", values.isFatca)
        formik.setFieldValue("isAgreeMITC", values.isAgreeMITC)
        formik.setFieldValue("isDDPIConsent", values.isDDPIConsent)
        formik.setFieldValue("isMTFDeclaration", values.isMTFDeclaration)
        formik.setFieldValue("isAgreeToConcent", values.isDeclared)
    }

    const getKRADetails = () => {
        axios.get(process.env.REACT_APP_API_URL + config.getKRA).then(resp => {
            if (resp.data.success) {
                setKRAData(resp.data.success)
                if (!resp.data.success.isKRAVerified) {
                    setShowFields({ CPOA: false, PPOA: false, CPOAdisabled: true, PPOAdisabled: true })
                }
                setIsEdit(!resp.data.success.isKRAVerified)
                // setShowFields({CPOA:true, PPOA:true, CPOAdisabled:true, PPOAdisabled:true})
                dispatch(addStageData({ ...store, isKRAVerified: resp.data.success.isKRAVerified }))
                setLoading(false)
            }
            else {
                throw new Error(resp.data.error)
            }
        }).catch((err) => {
            setLoading(false)
            console.log(err.message)
        })
    }

    const getAddressDetails = (isEdited) => {
        axios.get(process.env.REACT_APP_API_URL + config.getAddressDetails).then(resp => {
            setLoading(false)
            if (resp.data.success) {
                setUploadedDocuments({...uploadedDocuments, cpoa:resp.data.success[0].kycFormProofUpload?.filter(item=>item.documentTypeCode === "CPOA"), ppoa:resp.data.success[0].kycFormProofUpload?.filter(item=>item.documentTypeCode === "PPOA"), docChecked: true})
                initialAddressDetailsValues(resp.data.success[0], isEdited)
                setIsEdit(!resp.data.success[0].isKRAVerified)
                kraVerified=resp.data.success[0].isKRAVerified
                setShowFields({...showFields, CPOA:true, PPOA:true})
                dispatch(addStageData({ ...store, ...resp.data.success[0] }))
                setDocumentsUploadedDetails(resp.data.success[0].kycFormProofUpload.map(doc => { return { "documentOf": doc.documentTypeCode, "proofId": doc.kycstgProofId } }))
            }
            else {
                throw new Error(resp.data.error)
            }
        }).catch((err) => {
            setLoading(false)
            console.log(err.message)
        })
    }
    const getFATCAOptions = () => {
        axios.get(process.env.REACT_APP_API_URL + config.getFATCAOptions)
            .then(resp => {
                if (resp.data.success) {
                    var optionsData = resp.data.success;
                    const othersList = [{
                        "id": 5,
                        "natureOfBusinessDesc": "Others",
                        "isActive": true
                    }];
                    const natureOfBusinessAllList = [
                        {
                            "id": 1,
                            "natureOfBusinessDesc": "Manufacturing",
                            "isActive": true
                        },
                        {
                            "id": 2,
                            "natureOfBusinessDesc": "Services",
                            "isActive": true
                        },
                        {
                            "id": 3,
                            "natureOfBusinessDesc": "Trading",
                            "isActive": true
                        },
                        {
                            "id": 4,
                            "natureOfBusinessDesc": "Consultancy",
                            "isActive": true
                        },
                        {
                            "id": 5,
                            "natureOfBusinessDesc": "Others",
                            "isActive": true
                        }
                    ]
                    optionsData.occupationList?.map(occupation =>{
                        if(occupation.selectValue == "5-Private Sector"){
                            occupation["natureOfBusinessList"] = othersList
                            occupation["isOtherAllowed"] = false
                        }
                        else if(occupation.selectValue == "6-Public Sector"){
                            occupation["natureOfBusinessList"] = othersList
                            occupation["isOtherAllowed"] = false
                        }
                        else if(occupation.selectValue == "7-Govt. service"){
                            occupation["natureOfBusinessList"] = othersList
                            occupation["isOtherAllowed"] = false
                        }
                        else if(occupation.selectValue == "8-Professional"){
                            occupation["natureOfBusinessList"] = [{
                                "id": 2,
                                "natureOfBusinessDesc": "Services",
                                "isActive": true
                            }]
                        }
                        else if(occupation.selectValue == "9-Self Employed"){
                            occupation["natureOfBusinessList"] = natureOfBusinessAllList
                            occupation["isOtherAllowed"] = true
                        }
                        else if(occupation.selectValue == "10-Retired"){
                            occupation["natureOfBusinessList"] = othersList
                            occupation["isOtherAllowed"] = false
                        }
                        else if(occupation.selectValue == "11-Housewife"){
                            occupation["natureOfBusinessList"] = othersList
                            occupation["isOtherAllowed"] = false
                        }
                        else if(occupation.selectValue == "11-Housewife"){
                            occupation["natureOfBusinessList"] = othersList
                            occupation["isOtherAllowed"] = false
                        }
                        else if(occupation.selectValue == "12-Student"){
                            occupation["natureOfBusinessList"] = othersList
                            occupation["isOtherAllowed"] = false
                        }
                        else if(occupation.selectValue == "13-Business"){
                            occupation["natureOfBusinessList"] = natureOfBusinessAllList
                            occupation["isOtherAllowed"] = true
                        }
                    })
                    setOptions(resp.data.success)
                }
                else {
                    throw new Error(resp.data.error)
                }
            }).catch((err) => {
                console.log(err.message)
            })
    }

    const getFATCADetails = () => {
        axios.get(process.env.REACT_APP_API_URL + config.getFATCADetails)
            .then(resp => {
                if (resp.data.success) {
                    initialFATCADetailsValues(resp.data.success[0])
                    setFATCAData(resp.data.success[0])
                    setLoading(false)
                }
                else {
                    throw new Error(resp.data.error)
                }
            }).catch((err) => {
                setLoading(false)
                console.log(err.message)
            })
    }

    function handleSnackBarClose() {
        setSnackBarOpen(false)
        setResponseStatus()
    }

    const incomeNetWorthMapping = {
        1: { minNetWorth: 100000, maxNetWorth: 500000000 },
        2: { minNetWorth: 1000000, maxNetWorth: 500000000 },
        3: { minNetWorth: 5000000, maxNetWorth: 500000000 },
        4: { minNetWorth: 10000000, maxNetWorth: 500000000 },
        5: { minNetWorth: 25000000, maxNetWorth: 500000000 }
    };

    const handleAnnualIncomeRange = (e) => {
        const value = e.target.value;
        formik.setFieldValue("annualIncomeRange", e.target.value)
        if (e.target.value === 1) {
            formik.setFieldValue("networth", 1000000)
        } else if (e.target.value === 2) {
            formik.setFieldValue("networth", 1000000)
        } else if (e.target.value === 3) {
            formik.setFieldValue("networth", 5000000)
        } else if (e.target.value === 4) {
            formik.setFieldValue("networth", 10000000)
        } else if (e.target.value === 5) {
            formik.setFieldValue("networth", 25000000)
        } else {
            formik.setFieldValue("networth", "")
        }
    }

    const validationSchema = yup.object({
        corrFlatHouseNo: yup
            .string('')
            .matches( /^[a-zA-Z\d,.:/\\-]+(?: [a-zA-Z\d,.:/\\-]+)*$/ , localeText?.AddressValidFlatNo)
            .required(localeText?.AddressCorrespondenceFlatNo),
        corrColonyStreetLocality: yup
            .string('')
            .matches( /^[a-zA-Z\d,.:/\\-]+(?: [a-zA-Z\d,.:/\\-]+)*$/ , localeText?.AddressValidColony),
        corrTownArea: yup
            .string('')
            .nullable()
            .matches( /^[a-zA-Z\d,.:/\\-]+(?: [a-zA-Z\d,.:/\\-]+)*$/ , localeText?.AddressValidTown),
        corrPincode: yup
            .string('')
            .required(localeText?.AddressCorrespondencePincode),
        corrState: yup
            .string('')
            .required(localeText?.AddressCorrespondenceState),
        corrCity: yup
            .string('')
            .required(localeText?.AddressCorrespondenceCity),
        // sameAsCorrAddress: yup
        //     .boolean(''),
        permFlatHouseNo: yup
            .string('')
            .matches( /^[a-zA-Z\d,.:/\\-]+(?: [a-zA-Z\d,.:/\\-]+)*$/ , localeText?.AddressValidFlatNo)
            .required(localeText?.AddressPermanentFlatNo),
        permColonyStreetLocality: yup
            .string('')
            .matches( /^[a-zA-Z\d,.:/\\-]+(?: [a-zA-Z\d,.:/\\-]+)*$/ , localeText?.AddressValidColony),
        permTownArea: yup
            .string('')
            .nullable()
            .matches( /^[a-zA-Z\d,.:/\\-]+(?: [a-zA-Z\d,.:/\\-]+)*$/ , localeText?.AddressValidTown),
        permPincode: yup
            .string('')
            .required(localeText?.AddressPermanentPincode),
        permState: yup
            .string('')
            .required(localeText?.AddressPermanentState),
        permCity: yup
            .string('')
            .required(localeText?.AddressPermanentCity),
        annualIncomeRange: yup
            .string('')
            .required(localeText?.AddressAnnualIncome),
        networth: yup
            .number()
            .required(localeText.AddressNetWorthRequired)
            .test('is-valid-net-worth', function (value) {
                const { annualIncomeRange } = this.parent;
                const incomeRange = incomeNetWorthMapping[annualIncomeRange];
                console.log("value :::",value)
                if (!incomeRange) return true;

                const minNetWorth = 1;
                const maxNetWorth = incomeRange.maxNetWorth;

                const isValid = value >= minNetWorth && value <= maxNetWorth;
                return isValid || this.createError({ message: incomeRange.errorMessage });
        }),
        networthDate: yup
            .number()
            .required(localeText?.AddressNetWorthAsOnDateRequired),
        occupation: yup
            .string('')
            .required(localeText?.AddressOccupation),
        tradingExp: yup
            .number('')
            .max(25, localeText?.AddressTradingExperience).min(0, localeText?.AddressTradingExperience)
            .typeError(localeText?.loginInvalidNo),
        politicalAffiliation: yup
            .string('')
            .required(localeText?.AddressPolitical),
        natureOfBusiness: yup
            .string('')
            .required(localeText?.AddressNature),
        natureOfBusinessOther: yup
            .string('')
            .when('natureOfBusiness', {
                is: "5",
                then: yup.string('')
                    .required(localeText?.AddressOtherNature),
                otherwise: yup.string('').notRequired()
            }),
        sourceOfWealth: yup
            .string('')
            .required(localeText?.AddressSourceWealth),
        placeOfBirth: yup
            .string('')
            .matches(/^[a-zA-Z\d',.#&-\/]+(?: [a-zA-Z\d',.#&-\/]+)*$/, localeText?.AddressValidPlace)
            .required(localeText?.AddressPlaceBirth),
        countryOfBirth: yup
            .string('')
            .matches(/^[a-zA-Z\d',.#&-\/]+(?: [a-zA-Z\d',.#&-\/]+)*$/, localeText?.AddressValidCountry)
            .required(localeText?.AddressCountryBirth),
        // isFatca: yup
        //     .boolean(''),
        // agreementOfConsents: yup
        //     .boolean('')
    });

    const nextNavigation = () => {
        if (objectionState.isObjection) {
            objectionNavigation(navigate)
        }
        else {
            navigate("/NomineeDetails")
        }
    }
    
    const submitFATCADetails = (values) => {
        let dataObj = {}
        dataObj.kycIncomeSlab = Number(values.annualIncomeRange)
        dataObj.networth = Number(values.networth)
        dataObj.networthDate = Number(values.networthDate)
        dataObj.kycNatureOfBusiness = Number(values.natureOfBusiness)
        dataObj.kycOccupation = Number(values.occupation)
        dataObj.annualIncomeDelDate = ""
        dataObj.occupationOther = ""
        dataObj.politicallyExpPerson = values.politicalAffiliation
        dataObj.tradingExperience = values.tradingExp || "0"
        dataObj.isFatca = values.isFatca
        dataObj.isAgreeMITC=values.isAgreeMITC
        dataObj.isDDPIConsent=values.isDDPIConsent
        dataObj.isMTFDeclaration=values.isMTFDeclaration
        dataObj.isDeclared = values.isAgreeToConcent
        dataObj.addressType = ""
        dataObj.placeOfBirth = values.placeOfBirth
        dataObj.countryOfBirth = values.countryOfBirth
        dataObj.sourceOfWealth = Number(values.sourceOfWealth)
        dataObj.taxStatus = ""
        dataObj.natureOfBusinessOther = values.natureOfBusinessOther || ""
        dataObj.consent = checkedField
        axios.post(process.env.REACT_APP_API_URL + config.FATCADetails, dataObj)
            .then(resp => {
                if (resp.data.success) {
                    setLoading(false)
                    dispatch(addStageData({ ...store, addressFatcaDetails: values }))
                    dispatch(updateStepper({ step: 2, nestedStep: 2 }));
                    nextNavigation()
                }
                else {
                    throw new Error(resp.data.error)
                }
            }).catch((err) => {
                setLoading(false)
                setResponseStatus({ "message": err.message, "type": "error" })
                setSnackBarOpen(true)
            })

    }

    const submitAddressDetails = (values) => {
        setLoading(true)
        let objData = {}
        objData.loginId = "123"
        objData.permAddress1 = objData.corrAddress1 = values.corrFlatHouseNo || ""
        objData.permAddress2 = objData.corrAddress2 = values.corrColonyStreetLocality || ""
        objData.permAddress3 = objData.corrAddress3 = values.corrTownArea || ""
        objData.permLandMark = objData.corrLandMark = values.corrLandmark || ""
        objData.permAddressPinCode = objData.corrAddressPincode = values.corrPincode || ""
        objData.permAddressCity = objData.corrAddressCity = values.corrCity || ""
        objData.permAddressState = objData.corrAddressState = values.corrState || ""
        objData.permAddressCountry = objData.corrAddressCountry = "India"
        objData.sameAsCorrespondanceAddress = !!values.sameAsCorrAddress
        if (!values.sameAsCorrAddress) {
            objData.permAddress1 = values.permFlatHouseNo || ""
            objData.permAddress2 = values.permColonyStreetLocality || ""
            objData.permAddress3 = values.permTownArea || ""
            objData.permLandMark = values.permLandmark || ""
            objData.permAddressPinCode = values.permPincode || ""
            objData.permAddressCity = values.permCity || ""
            objData.permAddressState = values.permState || ""
        }
        objData.isAddChange = isEdit
        objData.isKRACorrespondanceAddChange = isEdit
        objData.isKRAPermanantAddChange = isEdit
        axios.post(process.env.REACT_APP_API_URL + config.addressDetails, objData)
            .then(resp => {
                if (resp.data.success) {
                    submitFATCADetails(values)
                }
                else {
                    throw new Error(resp.data.error)
                }
            }).catch((err) => {
                setLoading(false)
                setResponseStatus({ "message": err.message, "type": "error" })
                setSnackBarOpen(true)
            })
    }

    const handleSubmit = (values) => {
        console.log(uploadedDocuments, 'uploadedDocuments')
        if ((Object.keys(uploadedDocuments).length == 0 ||
            (values.sameAsCorrAddress && !Object.keys(uploadedDocuments).length) ||
            (values.sameAsCorrAddress && !uploadedDocuments.cpoa.find(doc => doc.documentTypeCode == 'CPOA')))) {
            setResponseStatus({ "message": localeText?.AddressMandatory, "type": "error" })
            setSnackBarOpen(true)
            return
        }

        submitAddressDetails(values)
    }

    const formik = useFormik({
        initialValues: {
            corrFlatHouseNo: '',
            corrColonyStreetLocality: "",
            corrTownArea: "",
            corrLandmark: "",
            corrPincode: "",
            corrState: "",
            corrCity: "",
            sameAsCorrAddress: true,
            permFlatHouseNo: "",
            permColonyStreetLocality: "",
            permTownArea: "",
            permLandmark: "",
            permPincode: "",
            permState: "",
            permCity: "",

            annualIncomeRange: "",
            networth:"",
            networthDate:getLastDateOfFinancialYear(),
            occupation: "",
            tradingExp: "",
            politicalAffiliation: "",
            natureOfBusiness: "",
            natureOfBusinessOther: "",
            sourceOfWealth: "",
            placeOfBirth: "",
            countryOfBirth: "",
            isFatca: false,
            isAgreeMITC:false,
            isDDPIConsent:false,
            isMTFDeclaration:false,
            isAgreeToConcent: false,
        },
        validationSchema: validationSchema,
        onSubmit: (values) => {
            handleSubmit(values)
        },
    });

    const handleSameAsCorrAddress = (e) => {
        let value = e.target.checked;
        console.log(e.target.checked, 'checked')
        if (value) {
            formik.setFieldValue("permFlatHouseNo", formik.values.corrFlatHouseNo)
            formik.setFieldValue("permColonyStreetLocality", formik.values.corrColonyStreetLocality)
            formik.setFieldValue("permTownArea", formik.values.corrTownArea)
            formik.setFieldValue("permLandmark", formik.values.corrLandmark)
            formik.setFieldValue("permPincode", formik.values.corrPincode)
            formik.setFieldValue("permState", formik.values.corrState)
            formik.setFieldValue("permCity", formik.values.corrCity)
        }else {
            formik.setFieldValue("permFlatHouseNo", "")
            formik.setFieldValue("permColonyStreetLocality", "")
            formik.setFieldValue("permTownArea", "")
            formik.setFieldValue("permLandmark", "")
            formik.setFieldValue("permPincode", "")
            formik.setFieldValue("permState", "")
            formik.setFieldValue("permCity", "")
            // initialAddressDetailsValues(null, true)
        }
    }

    const setPincodeSearchFields = (searchedItem, addressType) => {
            formik.setFieldValue("corrPincode", searchedItem.pinCode)
            formik.setFieldValue("corrState", searchedItem.state)
            formik.setFieldValue("corrCity", searchedItem.city)
            formik.setFieldValue("permPincode", searchedItem.pinCode)
            formik.setFieldValue("permState", searchedItem.state)
            formik.setFieldValue("permCity", searchedItem.city)
        setOpen({ ...open, [addressType]: false })
        setPincodeOptions([])
    }


    const autoPincodeSearch = (value, type) =>{
            if (value.length > 2 ) {
                if (timer) {
                    clearTimeout(timer)
                }
                timer = setTimeout(() => {
                    setPincodeOptions([])
                    let dataObj = {
                        key: value,
                        type: "pinCode"
                    }
                    axios.post(process.env.REACT_APP_API_URL + config.search, dataObj)
                        .then(resp => {
                            if (resp.data.success) {
                                setPincodeOptions(resp.data.success)
                                setPincodeSearchFields(resp.data.success[0], type)
                            }
                            else {
                                throw new Error(resp.data.error)
                            }
                        }).catch((error) => {
                            setResponseStatus({ "message": error.message, "type": "error" })
                            setSnackBarOpen(true)
                        })
                }, 1000)
            }
    }

    let timer;
    const handlePincodeSearch = (e) => {
        if (e.target.value.length > 2 || e.length > 2 ) {
            if (timer) {
                clearTimeout(timer)
            }
            timer = setTimeout(() => {
                setPincodeOptions([])
                let dataObj = {
                    key: e.target.value,
                    type: "pinCode"
                }
                axios.post(process.env.REACT_APP_API_URL + config.search, dataObj)
                    .then(resp => {
                        if (resp.data.success) {
                            setPincodeOptions(resp.data.success)
                        }
                        else {
                            throw new Error(resp.data.error)
                        }
                    }).catch((error) => {
                        setResponseStatus({ "message": error.message, "type": "error" })
                        setSnackBarOpen(true)
                    })
            }, 1000)
        }
    }

    const getOptionComponent = (searchedItem, addressType) => {
        return <Grid item css={{ width: "100%", padding: "20px", borderTop: "1px solid grey", cursor: "pointer" }} onClick={() => setPincodeSearchFields(searchedItem, addressType)}>
            <Typography variant='body1' css={{ fontWeight: "bold" }}>
                {localeText?.AddressPinCode + searchedItem.pinCode}
            </Typography>
            <Typography variant='body2'>
                {localeText?.AddressState + searchedItem.state}
            </Typography>
            <Typography variant='body2'>
                {localeText?.AddressCity + searchedItem.city}
            </Typography>
        </Grid>
    }

    const handleSameAsCorrespondenceChecked = (e, fieldName) => {
        if (formik.values.sameAsCorrAddress) {
            formik.setFieldValue(fieldName, e.currentTarget.value)
        }
    }

    function toogleInnerDialog() {
        setOpenInnerDialog(!openInnerDialog);
    }

    var getDocumentTypeOptions = (documentTypeCode, documentUploadedForValue, documentOfValue, screenOf) => {
        setDocumentTypeOption(documentTypeCode)
        setOpenInnerDialog(!openInnerDialog)
        setDocumentUploadedFor(documentUploadedForValue)
        setDocumentOf(documentOfValue)
        setDocumentOfScreen(screenOf)
    }

    const onFile = (prm, docId, count, name, mappingKey) => {
        prm.then(succ => {
            toogleInnerDialog()
            if (succ.type.includes("pdf")) {
                setPdf(succ)
                setPdfPopup(true)
            }
            else {
                setImage([succ.data])
                setUploadPopup(true)
            }
            setDocMId(docId)
            setNumberOfImages(count)
            setDocumentName(name)
            setDocumentMappingKey(mappingKey)
        })
    }

    var uploadDocument = (documentData) => {
        setLoading(true)
        let documentArr = [...documentsUploadedDetails];
        let count = 0;
        documentData.forEach(document => {
            axios.post(`${process.env.REACT_APP_API_URL}${config.uploadDocument}`, document)
                .then(response => {
                    count++;
                    setLoading(false)
                    if (response?.data?.success) {
                        var docNotUploaded = response?.data?.success.find(docResponse => docResponse.Status == false)
                        if (docNotUploaded) {
                            setResponseStatus({ "message": `${localeText?.AddressUpload}${docNotUploaded.uploadId}`, "type": "error" })
                            setSnackBarOpen(true)

                        }
                        else {
                            if (documentTypeOption.toLowerCase().includes("nom")) {
                                // store.dispatch(change("nomineeDetails", "nomineeIdentification"+currentDocumentIndex, documentMappingKey))
                                // store.dispatch(change("nomineeDetails", "nomineeIdentificationDetails"+currentDocumentIndex, ""))
                            }
                            else if (documentTypeOption.toLowerCase().includes("gurd")) {
                                // store.dispatch(change("nomineeDetails", "guardianIdentification"+currentDocumentIndex, documentMappingKey))
                                // store.dispatch(change("nomineeDetails", "guardianIdentificationDetails"+currentDocumentIndex, ""))
                            }
                            setResponseStatus({ "message": localeText?.AddressSuccessfully, "type": "success" })
                            setSnackBarOpen(true)
                            documentArr = [...documentArr, {
                                "documentTypeCode": document.docTypeCode,
                                "proofId": response.data.success[0].id,
                                "documentOf": documentOf,
                                "documentScreen": documentOfScreen
                            }]
                            count == documentData.length && setDocumentsUploadedDetails(documentArr)
                        }
                    }
                    if (response.data.error) {
                        setResponseStatus({ "message": response.data.error, "type": "error" })
                        setSnackBarOpen(true)
                    }
                })
                .catch(exception => {
                    setLoading(false)
                    setResponseStatus({ "message": exception.message, "type": "error" })
                    setSnackBarOpen(true)
                })
        })
    }

    const uploadImageProof = (data) => {
        if (data && data.length > 0) {
            var outData = data.map((dt, i) => dt && ({
                "pageNo": (i + 1),
                "pan": "", // pendingFormDetails ? pendingFormDetails.PanNo : (formValueSelector("accountDetails")(store.getState(0), "specialSegment")=="isDPOnly" && isMinorByDateSelected()) ? clientData.panNumber || formValueSelector("panCriteria")(store.getState(0), "panNumber") : formValueSelector("panCriteria")(store.getState(0), "panNumber"),
                "uploadId": (i + 1),
                "docTypeCode": documentTypeOption,
                "docMId": docMId,
                "type": documentUploadedFor,
                // "latitude": /* documentTypeOption == "Photo" ? geoLocationData.latitude : */ "",
                // "longitude": /* documentTypeOption == "Photo" ? geoLocationData.longitude : */ "",
                "objectionId": "",
                "fileType": dt.split(",")[0].split("/")[1].split(";")[0],
                "product": "diy",
                "base64Format": dt.split(",")[1],
                "isOcrRequired": true
            }))
            uploadDocument(outData)
        }
        setUploadPopup(false)

    }

    const uploadPdfProof = (pdfData, pdfName) => {
        setPdfPopup(false)
        var outData = [{
            "pageNo": "1",
            "pan": "", // pendingFormDetails ? pendingFormDetails.PanNo : (formValueSelector("accountDetails")(store.getState(0), "specialSegment")=="isDPOnly" && isMinorByDateSelected()) ? clientData.panNumber || formValueSelector("panCriteria")(store.getState(0), "panNumber") : formValueSelector("panCriteria")(store.getState(0), "panNumber"),
            "uploadId": "1",
            "docTypeCode": documentTypeOption,
            "docMId": docMId,
            "type": documentUploadedFor,
            // "latitude": /* documentTypeOption == "Photo" ? geoLocationData.latitude : */ "",
            // "longitude": /* documentTypeOption == "Photo" ? geoLocationData.longitude : */ "",
            "objectionId": "",
            "fileType": "pdf",
            "product": "diy",
            "base64Format": pdfData && pdfData.split(",")[1],
            "isOcrRequired": true
        }]
        if (pdfData !== null) {
            uploadDocument(outData)
        }
    }

    const toggleKRAVerifiedDataEdittingPopup = () => {
        setOpenKRAVerifiedDataPopup(!openKRAVerifiedDataPopup)
    }

    const handleEditClick = () => {
        formik.setFieldValue("sameAsCorrAddress", false)
        if (kRAData?.isKRAVerified || kraVerified) {
            toggleKRAVerifiedDataEdittingPopup()
        }
        else {
            toggleEdit()
        }
    }

    const toggleEdit = () => {
        setIsEdit(!isEdit)
        if (isEdit) {

        } else {
            setShowFields({ ...showFields, CPOA: false, PPOA: false })
        }
    }

    const handleTermsAndConditions = () =>{
        setLoading(true)
        axios.get(process.env.REACT_APP_STRAPI_URL + config.customerHandout).then(resp => {
          if (resp && resp[0]?.fileUrl) {
            setLoading(false)
            window.open(process.env.REACT_APP_STRAPI_URL + resp[0]?.fileUrl, "_blank")
          }
        }).catch(exception => {
            setLoading(false)
          console.log(exception.msg)
        });
      }

    const handleMitcConsentClose = () => {
        setMitcConsentOpen(false);
      };


    const handleMtfConsentClose = () => {
        setMtfConsentOpen(false);
      };


    const handleDdpiConsentClose = () => {
        setDdpiConsentOpen(false);
        setisDdpiCheckedField(initialDdpiConsentCheckBox)
      };



    const onConsentChange = (key, value) => {
        if(key == "pastAction" && !value){
            setCheckedField({
                ...checkedField,
                "pastActionReason": "",
                [key]: value
            });
        }
        else{
            setCheckedField({
                ...checkedField,
                [key]: value
            });
        }
    };

    const onDdpiConsentChange = (key, value) => {
            setisDdpiCheckedField({
                ...isDdpiCheckedField,
                [key]: value
            });
    };

    const handleConsentClose = () => {
        setConsentOpen(false);
        var tempInitialConsentCheckBox = initialConsentCheckBox;
        tempInitialConsentCheckBox["authRunningAccount"] = checkedField?.authRunningAccount
        setCheckedField(tempInitialConsentCheckBox)
    };

    const handleAgreementOfConsents = (e, type) => {
        if (type === 'consent') {
            formik.setFieldValue("isAgreeToTerms", e.currentTarget.checked)
            formik.setFieldValue("isAgreeToConcent", e.currentTarget.checked)
            formik.setFieldValue("isAgreeMITC", e.currentTarget.checked)
            formik.setFieldValue("isDDPIConsent", e.currentTarget.checked)
            formik.setFieldValue("isMTFDeclaration", e.currentTarget.checked)
        } else if (type === "isAgreeToConcent") {
            formik.setFieldValue("isAgreeToConcent", e.currentTarget.checked)
        } else if (type === "mitcConsent") {
            formik.setFieldValue("isAgreeMITC", e.currentTarget.checked)
        } else if (type === "ddpiConsent") {
            formik.setFieldValue("isDDPIConsent", e.currentTarget.checked)
        } else if (type === "mtfConsent") {
            formik.setFieldValue("isMTFDeclaration", e.currentTarget.checked)
        }
    }

    const handleAgreementOfConsentsOpen = (e, type) => {
        if (type === 'consent') {
            setConsentOpen(true);
        } else if (type === "mitcConsent") {
            setMitcConsentOpen(true);
        } else if (type === "ddpiConsent") {
            setDdpiConsentOpen(true);
        } else if (type === "mtfConsent") {
            setMtfConsentOpen(true);
        }
    }

    const changeNatureOfBusinessOthers=(e, dependentChange)=>{
        var otherData = options?.occupationList.find(occupation=> occupation.id == (dependentChange ? e.target.value : formik.values.occupation));
        formik.setFieldValue("natureOfBusinessOther", ((dependentChange ? formik.values.natureOfBusiness == 5 : e.target.value == 5) && !otherData?.isOtherAllowed) ?  otherData?.occupationName : "")
    }

    const showUpload = ()=>{
        if(uploadedDocuments?.docChecked && (objectionState?.isObjection === false || objectionState?.isObjection === true)){
            return true
        }else{
            return false
        }
    }
    console.log("Formik Values", formik?.values);
    console.log("Formik Errors", formik?.errors);
    return (
        <>
            <form autocomplete="off" onSubmit={formik.handleSubmit} css={{ width: "100%" }}>
                <PageLayout css={{ overflowY: "scroll" }} showSidebar isObjectionScreen={objectionState.isObjection}
                    breadcrumb={{ show: true, steps: steps[1].nestedSteps, step: 2, nestedStep: 2 }}>
                    <ElevatedGrid >
                        <Grid container item alignItems={"center"} spacing={3}>
                            <Grid container item alignItems={"center"}>
                                {objectionState.isObjection && <Grid item xs={12} css={{ padding: "10px", color: "white", backgroundColor: "lightcoral", borderRadius: "10px", margin: "10px 0px" }}>
                                    {objectionState.objections.map((objection, i) =>
                                        <>
                                            <Typography align="center" display="inline" variant="body2" fontWeight={"bold"}>
                                                {localeText?.profileObjection} {objection.objectionDescription || "--"} | {localeText?.profileObjectionRemark} {objection.remark || "--"} <br />
                                            </Typography>
                                            {i > 0 && <Divider />}
                                        </>
                                    )}
                                </Grid>}
                                <Grid item xs={12}>
                                    <Typography display="inline" fontSize={"24px"} fontWeight={"bold"} color="#525D72">
                                        {localeText?.Address}
                                    </Typography>
                                </Grid>
                                <Grid item xs={12} sx={{width:"100%"}}>
                                    <Typography display="inline" fontSize={"16px"} fontWeight={"bold"} color="black">
                                        {localeText?.AddressGuidelines} :
                                    </Typography>
                                    <List sx={{listStyle: "decimal", marginX: '20px', padding: 0, marginY: 0 }}>
                                        <ListItem sx={{ display: 'list-item', fontSize: "16px" }}>
                                            {localeText?.AddressGuideline1}
                                        </ListItem>
                                        <ListItem sx={{ display: 'list-item', fontSize: "16px",fontWeight:'bold', textTransform: 'uppercase',color:'red' }}>
                                            {localeText?.AddressGuideline2}
                                        </ListItem>
                                        <ListItem sx={{ display: 'list-item', fontSize: "16px" }}>
                                            {localeText?.AddressGuideline3}
                                        </ListItem>
                                    </List>
                                </Grid>
                            </Grid>

                            <Grid container item xs={12} xl={6} lg={12} md={12} spacing="12" css={{ marginTop: "5px" }}>
                                <Grid item xs={12} css={{ fontWeight: "bold" }}>
                                    {localeText?.AddressCorrespondence}
                                </Grid>
                                {
                                    (showFields?.CPOA) &&
                                    <>
                                        <Grid item xs={12} md={6}>
                                            <StyledTextField id="corrFlatHouseNo" name="corrFlatHouseNo" css={{ marginTop: "10px" }}
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                required
                                                value={(formik.values.corrFlatHouseNo)?.toUpperCase()}
                                                inputProps={{ maxLength: 50 }}
                                                error={formik.touched.corrFlatHouseNo && Boolean(formik.errors.corrFlatHouseNo)}
                                                helperText={formik.touched.corrFlatHouseNo && formik.errors.corrFlatHouseNo} fullWidth
                                                label={localeText?.AddressFlatNo} variant="outlined"
                                                disabled={!((stageDetailsData?.accountOpeningType == "KRA" && objectionState?.isObjection) || (stageDetailsData?.accountOpeningType?.trim() === "" && objectionState?.isObjection))}
                                                onChange={e => { handleSameAsCorrespondenceChecked(e, "permFlatHouseNo"); formik.handleChange(e) }}
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={6}>
                                            <StyledTextField id="corrColonyStreetLocality" name="corrColonyStreetLocality" css={{ marginTop: "10px" }}
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                inputProps={{ maxLength: 50 }}
                                                value={formik.values.corrColonyStreetLocality}
                                                error={formik.touched.corrColonyStreetLocality && Boolean(formik.errors.corrColonyStreetLocality)}
                                                helperText={formik.touched.corrColonyStreetLocality && formik.errors.corrColonyStreetLocality} fullWidth
                                                label={localeText?.AddressColony} variant="outlined"
                                                disabled={!((stageDetailsData?.accountOpeningType == "KRA" && objectionState?.isObjection) || (stageDetailsData?.accountOpeningType?.trim() === "" && objectionState?.isObjection))}
                                                onChange={e => { handleSameAsCorrespondenceChecked(e, "permColonyStreetLocality"); formik.handleChange(e) }}
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={6}>
                                            <StyledTextField id="corrTownArea" name="corrTownArea" css={{ marginTop: "10px" }}
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                inputProps={{ maxLength: 50 }}
                                                value={(formik.values.corrTownArea)?.toUpperCase()}
                                                error={formik.touched.corrTownArea && Boolean(formik.errors.corrTownArea)}
                                                helperText={formik.touched.corrTownArea && formik.errors.corrTownArea} fullWidth
                                                label={localeText?.AddressTownArea} variant="outlined"
                                                disabled={!((stageDetailsData?.accountOpeningType == "KRA" && objectionState?.isObjection) || (stageDetailsData?.accountOpeningType?.trim() === "" && objectionState?.isObjection))}
                                                onChange={e => { handleSameAsCorrespondenceChecked(e, "permTownArea"); formik.handleChange(e) }}
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={6}>
                                            <Autocomplete
                                                css={{ marginTop: "10px" }}
                                                id="corrPincode" name="corrPincode"
                                                value={formik.values.corrPincode}
                                                open={open?.corr}
                                                onOpen={() => {
                                                    setOpen({ ...open, corr: true });
                                                }}
                                                onClose={() => {
                                                    setOpen({ ...open, corr: false });
                                                }}
                                                disabled={!((stageDetailsData?.accountOpeningType == "KRA" && objectionState?.isObjection) || (stageDetailsData?.accountOpeningType?.trim() === "" && objectionState?.isObjection))}
                                                options={pincodeOptions}
                                                disablePortal
                                                filterOptions={(x) => x}
                                                loading={open?.corr && pincodeOptions.length == 0}
                                                renderOption={(props, searchedItem, state) => {
                                                    return getOptionComponent(searchedItem, "corr")
                                                }}
                                                isOptionEqualToValue={(option, value) => { return option.pinCode === value }}
                                                getOptionLabel={(option) => { return option }}
                                                renderInput={(params) => <StyledTextField {...params} fullWidth variant="outlined" label={localeText?.AddressPinC}
                                                    onChange={e => handlePincodeSearch(e, "corr")}
                                                    InputLabelProps={{
                                                        shrink: true,
                                                    }}
                                                    required
                                                    size="small"
                                                    id="corrPincode" name="corrPincode"
                                                    error={formik.touched.corrPincode && Boolean(formik.errors.corrPincode)}
                                                    helperText={formik.touched.corrPincode && formik.errors.corrPincode}
                                                />}
                                            />
                                        </Grid>
                                        <Grid item xs={6} md={3}>
                                            <StyledTextField id="corrState" name="corrState" css={{ marginTop: "10px" }}
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                value={(formik.values.corrState)?.toUpperCase()}
                                                error={formik.touched.corrState && Boolean(formik.errors.corrState)}
                                                helperText={formik.touched.corrState && formik.errors.corrState} fullWidth
                                                label={localeText?.AddressS} variant="outlined"
                                                disabled
                                                required
                                                onChange={e => { handleSameAsCorrespondenceChecked(e, "permState"); formik.handleChange(e) }}
                                            />
                                        </Grid>
                                        <Grid item xs={6} md={3}>
                                            <StyledTextField id="corrCity" name="corrCity" css={{ marginTop: "10px" }}
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                value={(formik.values.corrCity)?.toUpperCase()}
                                                error={formik.touched.corrCity && Boolean(formik.errors.corrCity)}
                                                helperText={formik.touched.corrCity && formik.errors.corrCity} fullWidth
                                                label={localeText?.AddressC} variant="outlined"
                                                disabled
                                                required
                                                onChange={e => { handleSameAsCorrespondenceChecked(e, "permCity"); formik.handleChange(e) }}
                                            />
                                        </Grid>
                                    </>
                                }
                                {showUpload() &&
                                    <Grid item xs={12} >
                                    <Upload
                                        masterId={'3'}
                                        title={localeText?.AddressProof}
                                        documentOptionData={{ id: "CPOA", type: "holder1", code: "CPOA", screen: "" }}
                                        setUploadedDocuments={(data) => {
                                            setUploadedDocuments({ ...uploadedDocuments, cpoa: data })
                                        }}
                                        uploadedDocuments={uploadedDocuments?.cpoa || []}
                                        isRequired={true}
                                        setOcrUploadLoading={setOcrUploadLoading}
                                        ocrUploadLoading={ocrUploadLoading}
                                        limitPdfPages={1}
                                        getAllAdressData={getAllAdressData}
                                        isAddressDetails={true}
                                        isObjection={objectionState?.isObjection}
                                        setAINxDocumentFailedPopup={setAINxDocumentFailedPopup}
                                    />
                                </Grid>}
                            </Grid>

                            <Grid container item xs={12} xl={6} lg={12} md={12} spacing="12" css={{ marginTop: "5px", alignSelf: "flex-start" }}>
                                <Grid container item xs={12} css={{ fontWeight: "bold", marginRight: "10px" }}>
                                    <Grid item css={{ fontWeight: "bold" }}>
                                        <Typography display="inline" fontWeight={"bold"}>
                                            {localeText?.AddressPermanent}
                                        </Typography>
                                    </Grid>
                                    <Grid item css={{ marginLeft: "10px" }}>
                                        <FormControl disabled={true}>
                                            <FormControlLabel control={<Checkbox css={{ padding: 0, marginRight: "5px", marginLeft: "10px" }} name="sameAsCorrAddress" id="sameAsCorrAddress" checked={formik.values.sameAsCorrAddress} onChange={e => { handleSameAsCorrAddress(e); formik.setFieldValue("sameAsCorrAddress", e.currentTarget.checked) }} />}
                                                label={<Typography variant='body2'>
                                                    {localeText?.AddressSameAs}
                                                </Typography>}
                                            />
                                        </FormControl>
                                    </Grid>
                                </Grid>
                                {
                                    (showFields?.PPOA) &&
                                    <>
                                        <Grid item xs={12} md={6}>
                                            <StyledTextField id="permFlatHouseNo" name="permFlatHouseNo" css={{ marginTop: "10px" }}
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                required
                                                inputProps={{ maxLength: 50 }}
                                                value={(formik.values.permFlatHouseNo)?.toUpperCase()}
                                                error={formik.touched.permFlatHouseNo && Boolean(formik.errors.permFlatHouseNo)}
                                                helperText={formik.touched.permFlatHouseNo && formik.errors.permFlatHouseNo} fullWidth
                                                label={localeText?.AddressFlatNo} variant="outlined"
                                                onChange={formik.handleChange}
                                                disabled={true}
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={6}>
                                            <StyledTextField id="permColonyStreetLocality" name="permColonyStreetLocality" css={{ marginTop: "10px" }}
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                inputProps={{ maxLength: 50 }}
                                                value={(formik.values.permColonyStreetLocality)?.toUpperCase()}
                                                error={formik.touched.permColonyStreetLocality && Boolean(formik.errors.permColonyStreetLocality)}
                                                helperText={formik.touched.permColonyStreetLocality && formik.errors.permColonyStreetLocality} fullWidth
                                                label={localeText?.AddressColony} variant="outlined"
                                                onChange={formik.handleChange}
                                                disabled={true}
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={6}>
                                            <StyledTextField id="permTownArea" name="permTownArea" css={{ marginTop: "10px" }}
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                inputProps={{ maxLength: 50 }}
                                                value={(formik.values.permTownArea)?.toUpperCase()}
                                                error={formik.touched.permTownArea && Boolean(formik.errors.permTownArea)}
                                                helperText={formik.touched.permTownArea && formik.errors.permTownArea} fullWidth
                                                label={localeText?.AddressTownArea} variant="outlined"
                                                onChange={formik.handleChange}
                                                disabled={true}
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={6}>
                                            <Autocomplete
                                                css={{ marginTop: "10px" }}
                                                id="permPincode" name="permPincode"
                                                value={formik.values.permPincode}
                                                open={open?.perm}
                                                onOpen={() => {
                                                    setOpen({ ...open, perm: true });
                                                }}
                                                onClose={() => {
                                                    setOpen({ ...open, perm: false });
                                                }}
                                                disabled={true}
                                                options={pincodeOptions}
                                                disablePortal
                                                filterOptions={(x) => x}
                                                loading={open?.perm && pincodeOptions.length == 0}
                                                renderOption={(props, searchedItem, state) => {
                                                    return getOptionComponent(searchedItem, "perm")
                                                }}
                                                isOptionEqualToValue={(option, value) => { return option.pinCode === value }}
                                                getOptionLabel={(option) => { return option }}
                                                renderInput={(params) => <StyledTextField {...params} fullWidth variant="outlined" label={localeText?.AddressPinC}
                                                    onChange={e => handlePincodeSearch(e, "perm")}
                                                    id="permPincode" name="permPincode"
                                                    InputLabelProps={{
                                                        shrink: true,
                                                    }}
                                                    required
                                                    size="small"
                                                    error={formik.touched.permPincode && Boolean(formik.errors.permPincode)}
                                                    helperText={formik.touched.permPincode && formik.errors.permPincode}
                                                />}
                                            />
                                        </Grid>
                                        <Grid item xs={6} md={3}>
                                            <StyledTextField id="permState" name="permState" css={{ marginTop: "10px" }}
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                required
                                                value={(formik.values.permState)?.toUpperCase()}
                                                error={formik.touched.permState && Boolean(formik.errors.permState)}
                                                helperText={formik.touched.permState && formik.errors.permState} fullWidth
                                                label={localeText?.AddressS} variant="outlined"
                                                disabled
                                                onChange={formik.handleChange}
                                            />
                                        </Grid>
                                        <Grid item xs={6} md={3}>
                                            <StyledTextField id="permCity" name="permCity" css={{ marginTop: "10px" }}
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                required
                                                value={(formik.values.permCity)?.toUpperCase()}
                                                error={formik.touched.permCity && Boolean(formik.errors.permCity)}
                                                helperText={formik.touched.permCity && formik.errors.permCity} fullWidth
                                                label={localeText?.AddressC} variant="outlined"
                                                disabled
                                                onChange={formik.handleChange}
                                            />
                                        </Grid>
                                    </>
                                }
                                {(isEdit && !formik.values.sameAsCorrAddress) && <Grid item xs={12}>
                                    {/* <UploadIcon
                                        isSVG={true}
                                        uploadDocument={() => getDocumentTypeOptions("PPOA", "holder1", "PPOA", "")}
                                        required={!formik.values.sameAsCorrAddress}
                                        uploaded={documentsUploadedDetails.find(holder => holder.documentOf == "PPOA" ? true : false)}
                                        loading={false}
                                        image={documentICONS["PPOA"]}
                                        pgloading={false}
                                        loader={null}
                                        disableCursorForUploaded={formik.values.sameAsCorrAddress}
                                    >
                                        {localeText?.AddressProof}
                                    </UploadIcon> */}
                                </Grid>}
                            </Grid>

                            <Grid container item xs={12} spacing="12" css={{ marginTop: "5px" }}>
                                <Grid item xs={12} css={{ fontWeight: "bold", alignSelf: "center", paddingBottom: "20px" }}>
                                    <Divider />
                                </Grid>
                                <Grid item xs={12} css={{ fontWeight: "bold", alignSelf: "center", paddingBottom: "20px" }}>
                                    <Typography display="inline" fontSize={"24px"} fontWeight={"bold"} color="#525D72">
                                        {localeText?.AddressFatca}
                                    </Typography>
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <FormControl required fullWidth error={formik.touched.annualIncomeRange && Boolean(formik.errors.annualIncomeRange)} css={{ marginTop: "10px" }}>
                                        <InputLabel
                                            shrink
                                        >
                                            {localeText?.AddressSelectAnnual}
                                        </InputLabel>
                                        <Select
                                            id="annualIncomeRange"
                                            name="annualIncomeRange"
                                            value={formik.values.annualIncomeRange}
                                            onChange={e => handleAnnualIncomeRange(e)}
                                            size="small"
                                            input={
                                                <OutlinedInput
                                                    notched
                                                    label={localeText?.AddressSelectAnnual}
                                                />
                                            }
                                        >
                                            <MenuItem value="">{localeText?.AddressSelect}</MenuItem>
                                            {options?.annualIncomeSlabList?.map(opt => <MenuItem value={opt.id}>{opt.slabRange}</MenuItem>)}
                                        </Select>
                                        <FormHelperText>{formik.touched.annualIncomeRange && formik.errors.annualIncomeRange}</FormHelperText>
                                    </FormControl>
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <StyledTextField id="networth" name="networth" css={{ marginTop: "10px" }}
                                        label={localeText?.AddressNetWorth} variant="outlined"
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                        required
                                        // inputProps={{ maxLength: 2 }}
                                        value={formik.values.networth}
                                        error={formik.touched.networth && Boolean(formik.errors.networth)}
                                        helperText={formik.touched.networth && formik.errors.networth} fullWidth
                                        onChange={formik.handleChange}  
                                    />
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                        <DatePicker
                                            label={localeText?.AddressNetWorthAsOnDate}
                                            css={{ width: "100%", marginTop: "10px" }}
                                            inputFormat="DD/MM/YYYY"
                                            id="networthDate"
                                            views={['year', 'month', 'day']}
                                            name="networthDate"
                                            value={getLastDateOfFinancialYear()}
                                            onChange={e => {
                                                formik.setFieldValue("networthDate", getLastDateOfFinancialYear());
                                            }}
                                            disabled={true}
                                            renderInput={(params) => (
                                                <StyledTextField
                                                    fullWidth
                                                    required
                                                    error={formik.touched.networthDate && Boolean(formik.errors.networthDate)}
                                                    helperText={formik.touched.networthDate && formik.errors.networthDate}
                                                    {...params}
                                                />
                                            )}
                                        />
                                    </LocalizationProvider>
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <FormControl required fullWidth error={formik.touched.occupation && Boolean(formik.errors.occupation)} css={{ marginTop: "10px" }}>
                                        <InputLabel
                                            shrink
                                        >
                                            {localeText?.AddressSelectOccupation}
                                        </InputLabel>
                                        <Select
                                            id="occupation"
                                            name="occupation"
                                            value={formik.values.occupation}
                                            onChange={e => {changeNatureOfBusinessOthers(e, true); formik.handleChange(e)}}
                                            size="small"
                                            input={
                                                <OutlinedInput
                                                    notched
                                                    label={localeText?.AddressSelectOccupation}
                                                />
                                            }
                                        >
                                            <MenuItem value="">{localeText?.AddressSelect}</MenuItem>
                                            {options?.occupationList?.filter(opt => !opt.isParent)?.map(opt => <MenuItem value={opt.id}>{opt.occupationName}</MenuItem>)}
                                        </Select>
                                        <FormHelperText>{formik.touched.occupation && formik.errors.occupation}</FormHelperText>
                                    </FormControl>
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <FormControl required fullWidth error={formik.touched.natureOfBusiness && Boolean(formik.errors.natureOfBusiness)} css={{ marginTop: "10px" }}>
                                        <InputLabel
                                            shrink
                                        >
                                            {localeText?.AddressSelectNature}
                                        </InputLabel>
                                        <Select
                                            id="natureOfBusiness"
                                            name="natureOfBusiness"
                                            value={formik.values.natureOfBusiness}
                                            onChange={ (e)=>{formik.setFieldValue("natureOfBusinessOther", options?.occupationList.find(occupation => occupation.id == formik?.values?.occupation)?.isOtherAllowed ? "": options?.occupationList.find(occupation=> occupation.id == formik?.values?.occupation)?.occupationName); formik.handleChange(e)}}
                                            size="small"
                                            input={
                                                <OutlinedInput
                                                    notched
                                                    label={localeText?.AddressSelectNature}
                                                />
                                            }
                                        >
                                            <MenuItem value="">{localeText?.AddressSelect}</MenuItem>
                                            {options?.occupationList.find(occupation=> occupation.id == formik?.values?.occupation)?.natureOfBusinessList?.map(opt => <MenuItem value={opt.id}>{opt.natureOfBusinessDesc}</MenuItem>)}
                                        </Select>
                                        <FormHelperText>{formik.touched.natureOfBusiness && formik.errors.natureOfBusiness}</FormHelperText>
                                    </FormControl>
                                </Grid>
                                {formik.values.natureOfBusiness == 5 && <Grid item xs={12} md={6}>
                                    <StyledTextField id="natureOfBusinessOther" name="natureOfBusinessOther" css={{ marginTop: "10px" }}
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                        required ={formik.values.natureOfBusiness == 5}
                                        disabled ={!(options?.occupationList.find(occupation=> occupation.id == formik?.values?.occupation)?.isOtherAllowed)}
                                        value={formik?.values?.natureOfBusinessOther}
                                        error={formik.touched.natureOfBusinessOther && Boolean(formik.errors.natureOfBusinessOther)}
                                        helperText={formik.touched.natureOfBusinessOther && formik.errors.natureOfBusinessOther} fullWidth
                                        label={localeText?.AddressBusinessNature} variant="outlined"
                                        onChange={formik.handleChange}
                                    />
                                </Grid>}
                                <Grid item xs={12} md={6}>
                                    <StyledTextField id="tradingExp" name="tradingExp" css={{ marginTop: "10px" }}
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                        required
                                        inputProps={{ maxLength: 2 }}
                                        value={formik.values.tradingExp}
                                        error={formik.touched.tradingExp && Boolean(formik.errors.tradingExp)}
                                        helperText={formik.touched.tradingExp && formik.errors.tradingExp} fullWidth
                                        label={localeText?.AddressTradingYears} variant="outlined"
                                        onChange={formik.handleChange}
                                    />
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <FormControl required fullWidth error={formik.touched.politicalAffiliation && Boolean(formik.errors.politicalAffiliation)} css={{ marginTop: "10px" }}>
                                        <InputLabel
                                            shrink
                                        >
                                            {localeText?.AddressSelectPolitical}
                                        </InputLabel>
                                        <Select
                                            id="politicalAffiliation"
                                            name="politicalAffiliation"
                                            value={formik.values.politicalAffiliation}
                                            onChange={formik.handleChange}
                                            size="small"
                                            input={
                                                <OutlinedInput
                                                    notched
                                                    label={localeText?.AddressSelectPolitical}
                                                />
                                            }

                                        >
                                            <MenuItem value="">{localeText?.AddressSelect}</MenuItem>
                                            {options?.pepStatusList?.map(opt => <MenuItem value={opt.Code}>{opt.Description}</MenuItem>)}
                                        </Select>
                                        <FormHelperText>{formik.touched.politicalAffiliation && formik.errors.politicalAffiliation}</FormHelperText>
                                    </FormControl>
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <FormControl required fullWidth error={formik.touched.sourceOfWealth && Boolean(formik.errors.sourceOfWealth)} css={{ marginTop: "10px" }}>
                                        <InputLabel
                                            shrink
                                        >
                                            {localeText?.AddressSelectSource}
                                        </InputLabel>
                                        <Select
                                            id="sourceOfWealth"
                                            name="sourceOfWealth"
                                            value={formik.values.sourceOfWealth}
                                            onChange={formik.handleChange}
                                            size="small"
                                            input={
                                                <OutlinedInput
                                                    notched
                                                    label={localeText?.AddressSelectSource}
                                                />
                                            }
                                        >
                                            <MenuItem value="">{localeText?.AddressSelect}</MenuItem>
                                            {options?.wealthMasterList?.map(opt => <MenuItem value={opt.id}>{opt.sourceOfWealthName}</MenuItem>)}
                                        </Select>
                                        <FormHelperText>{formik.touched.sourceOfWealth && formik.errors.sourceOfWealth}</FormHelperText>
                                    </FormControl>
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <StyledTextField id="placeOfBirth" name="placeOfBirth" css={{ marginTop: "10px" }}
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                        required
                                        value={formik.values.placeOfBirth}
                                        error={formik.touched.placeOfBirth && Boolean(formik.errors.placeOfBirth)}
                                        helperText={formik.touched.placeOfBirth && formik.errors.placeOfBirth} fullWidth
                                        label={localeText?.AddressPlaceOfBirth} variant="outlined"
                                        onChange={formik.handleChange}
                                    />
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <FormControl required fullWidth error={formik.touched.countryOfBirth && Boolean(formik.errors.countryOfBirth)} css={{ marginTop: "10px" }}>
                                        <InputLabel
                                            shrink
                                        >
                                            {localeText?.AddressCountryOfBirth}
                                        </InputLabel>
                                        <Select
                                            id="countryOfBirth"
                                            name="countryOfBirth"
                                            value={formik.values.countryOfBirth}
                                            onChange={formik.handleChange}
                                            size="small"
                                            input={
                                                <OutlinedInput
                                                    notched
                                                    label={localeText?.AddressCountryOfBirth}
                                                />
                                            }
                                        >
                                            <MenuItem value="">{localeText?.AddressSelect}</MenuItem>
                                            <MenuItem value={"India"}>{localeText?.AddressCountry}</MenuItem>
                                        </Select>
                                        <FormHelperText>{formik.touched.countryOfBirth && formik.errors.countryOfBirth}</FormHelperText>
                                    </FormControl>
                                </Grid>
                                <ConsentAgreementSection
                                    formik={formik}
                                    handleAgreementOfConsents={handleAgreementOfConsents}
                                    handleAgreementOfConsentsOpen={handleAgreementOfConsentsOpen}
                                    handleTermsAndConditions={handleTermsAndConditions}
                                />
                            </Grid>

                        </Grid>
                        <Grid item css={{ marginTop: "40px" }}>
                            <Button type="submit" variant='contained' color="secondary" disabled={!formik.values.isFatca || !formik.values.isAgreeMITC || !formik.values.isDDPIConsent || !formik.values.isAgreeToConcent || (formik.values.politicalAffiliation !== "Not Applicable")} >
                                {localeText?.profileSave}
                            </Button>
                        </Grid>
                    </ElevatedGrid>
                </PageLayout>
            </form>
            {loading && <FullScreenLoader />}
            {documentTypeOption && <ProofDialog setId={setId} 
            onFile={onFile} getDocumentTypeURL={config.documentMaster + "2"} open={openInnerDialog} dialogTitle={documentTypePerName[documentTypeOption]}
             handleClose={toogleInnerDialog} data={documentTypeOption} limitPdfPages={1} />}
            {showUploadPopup &&
                <DialogForUpload open={showUploadPopup} handleClose={() => { setUploadPopup(false); setDocumentName(""); setNumberOfImages(1); setDocMId() }} {...props} fullWidth={true} maxWidth='md'>
                    <UploadDialog
                        id={id}
                        multiple={numberOfImages} /// gives count to images to upload
                        handleClose={() => { setUploadPopup(false); setDocumentName(""); setNumberOfImages(1); setDocMId() }}
                        title={documentName}
                        imageArray={image ? image : null}
                        count={numberOfImages}  /// gives count to images to upload
                        onSave={(data) => { uploadImageProof(data); setDocumentName(""); setNumberOfImages(1); setDocMId() }}
                    />
                </DialogForUpload>}
            {showPdfPopup &&
                <DialogForUpload open={showPdfPopup} handleClose={() => { setPdfPopup(false); setDocumentName(""); setNumberOfImages(1); setDocMId() }} {...props} fullWidth={false} maxWidth='md'>
                    <UploadPdf
                        title={"Upload Pdf"}
                        file={pdf.data}
                        pdfName={pdf.name}
                        handleClose={() => { setPdfPopup(false); setDocumentName(""); setNumberOfImages(1); setDocMId() }}
                        onUpload={(pdfData, pdfName) => { uploadPdfProof(pdfData, pdfName); setDocumentName(""); setNumberOfImages(1); setDocMId() }}
                    />
                </DialogForUpload>}

            <Popup
                open={openKRAVerifiedDataPopup}
                maxWidth={"sm"}
            >
                <PopupTitle onClose={toggleKRAVerifiedDataEdittingPopup}>{localeText?.AddressConfirmation}</PopupTitle>
                <DialogContent >
                    {
                        Boolean(kRAData?.isKRAVerified) &&
                        <Grid sx={{ "& .MuiPaper-root": { color: '#24B7CC !important' } }}>
                        <ul style={{ color: '#24B7CC !important', paddingRight: '15px' }}>
                            <li>
                                <p>{localeText?.manualKRAAdressDataRecieved}</p>
                            </li>
                            <li>
                            <p>{localeText?.manualKRAAdressDataWillChange}</p>
                            </li>
                            <li>
                                <p>{localeText?.manualKRAAdressDataShouldUpload}</p>
                            </li>
                        </ul>
                    </Grid>
                    }

                </DialogContent>
                <DialogActions>
                    <Grid /* direction={"row-reverse"} */ alignItems={"center"} justifyContent={"flex-end"} container spacing={2} css={{ padding: "10px" }}>
                        <Grid item>
                            <Button variant="contained" color="primary" onClick={toggleKRAVerifiedDataEdittingPopup}>
                                {localeText?.AddressCancel}
                            </Button>
                        </Grid>
                        <Grid item>
                            <Button variant="outlined" color="primary" onClick={() => { toggleKRAVerifiedDataEdittingPopup(); toggleEdit(); }}>
                               {localeText?.AddressOk}
                            </Button>
                        </Grid>
                    </Grid>
                </DialogActions>
            </Popup>
            {
                <Popup
                    open={consentOpen}
                    maxWidth={"lg"}
                >
                    <PopupTitle onClose={handleConsentClose} dontShowCloseIcon customCSS={{ textAlign: "center" }}>{localeText?.AddressInstructions}
                        <Typography variant="body1" style={{ color: "#939393" }}>
                            <span style={{ fontWeight: "600", color: "#939393" }}>{localeText?.AddressNoWaiver}</span > {localeText?.AddressForBearance}
                        </Typography></PopupTitle>
                    <DialogContent>
                        <Table>
                            <TableHead>
                                <TableCell style ={{background:"#24B7CC", color: "white"}}>Consent Tearms</TableCell>
                                <TableCell style ={{background:"#24B7CC",borderLeft:"2px solid rgb(216 216 216)", color: "white"}}>Yes/ No</TableCell>
                            </TableHead>
                            <TableBody>
                            <TableRow>
                                {/* Concent to be not written in Language files since the statement below is as per circulars given by SEBI and other government institutes published time to time. */}
                                <TableCell style={{ background: "#F4F4F4"  }}>{`To receive / accept each and every credit and pledge instruction in my account`}</TableCell>
                                    <TableCell style={{ background: "#D8D8D8" , width: "200px", textAlign: "center" }}>
                                        <FormControl>
                                            <FormControlLabel style={{margin:0}} control={<Checkbox name={"creditPledgeInstruction"} id={"creditPledgeInstruction"} checked={checkedField["creditPledgeInstruction"]} onChange={(e) => onConsentChange("creditPledgeInstruction", e.target.checked)} />}
                                            />
                                        </FormControl>
                                    </TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell style={{ background: "#FFF"  }}>{`To send Electronic Transaction, Holding Statement, ECN / Bill & all correspondence at 1st Holder Email ID stated in KYC`}</TableCell>
                                    <TableCell style={{ background: "#F4F4F4" , width: "200px", textAlign: "center" }}>
                                        <FormControl>
                                            <FormControlLabel style={{margin:0}} control={<Checkbox name={"electronicContractNoteNstatement"} id={"electronicContractNoteNstatement"} checked={checkedField["electronicContractNoteNstatement"]} onChange={(e) => onConsentChange("electronicContractNoteNstatement", e.target.checked)} />}
                                            />
                                        </FormControl>
                                    </TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell style={{ background: "#F4F4F4"  }}>{`To share email id with Registrar & Transfer Agent (RTA)`}</TableCell>
                                    <TableCell style={{ background: "#D8D8D8" , width: "200px", textAlign: "center" }}>
                                        <FormControl>
                                            <FormControlLabel style={{margin:0}} control={<Checkbox name={"shareEmailWithRegistrarNrta"} id={"shareEmailWithRegistrarNrta"} checked={checkedField["shareEmailWithRegistrarNrta"]} onChange={(e) => onConsentChange("shareEmailWithRegistrarNrta", e.target.checked)} />}
                                            />
                                        </FormControl>
                                    </TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell style={{ background: "#FFF"  }}>{`Dividend / Interest to receive in bank account stated in KYC via ECS`}</TableCell>
                                    <TableCell style={{ background: "#F4F4F4" , width: "200px", textAlign: "center" }}>
                                        <FormControl>
                                            <FormControlLabel style={{margin:0}} control={<Checkbox name={"dividendInterestinBankAc"} id={"dividendInterestinBankAc"} checked={checkedField["dividendInterestinBankAc"]} onChange={(e) => onConsentChange("dividendInterestinBankAc", e.target.checked)} />}
                                            />
                                        </FormControl>
                                    </TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell style={{ background: "#F4F4F4"  }}>{`To avail facility of Internet Trading & Wireless Technology`}</TableCell>
                                    <TableCell style={{ background: "#D8D8D8" , width: "200px", textAlign: "center" }}>
                                        <FormControl>
                                            <FormControlLabel style={{margin:0}} control={<Checkbox name={"internetTrading"} id={"internetTrading"} checked={checkedField["internetTrading"]} onChange={(e) => onConsentChange("internetTrading", e.target.checked)} />}
                                            />
                                        </FormControl>
                                    </TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell style={{ background: "#FFF"  }}>{`To receive Annual Report in Electronic mode`}</TableCell>
                                    <TableCell style={{ background: "#F4F4F4" , width: "200px", textAlign: "center" }}>
                                        <FormControl>
                                            <FormControlLabel style={{margin:0}} control={<Checkbox name={"electronicAnnualReport"} id={"electronicAnnualReport"} checked={checkedField["electronicAnnualReport"]} onChange={(e) => onConsentChange("electronicAnnualReport", e.target.checked)} />}
                                            />
                                        </FormControl>
                                    </TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell style={{ background: "#F4F4F4"  }}>{`To receive Rights & Obligations, RDD, Guidance Note, Policies & Procedures & all non mandatory documents in electronic and also displayed for information on website www.tradebulls.in`}</TableCell>
                                    <TableCell style={{ background: "#D8D8D8" , width: "200px", textAlign: "center" }}>
                                        <FormControl>
                                            <FormControlLabel style={{margin:0}} control={<Checkbox name={"rightObligation"} id={"rightObligation"} checked={checkedField["rightObligation"]} onChange={(e) => onConsentChange("rightObligation", e.target.checked)} />}
                                            />
                                        </FormControl>
                                    </TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell style={{ background: "#FFF"  }}>{`To receive Physical Delivery Instruction Slip`}</TableCell>
                                <TableCell style={{ background: "#D8D8D8" , width: "200px", textAlign: "center" }}>
                                    <FormControl>
                                        <FormControlLabel style={{margin:0}} control={<Checkbox name={"receiveDisslip"} id={"receiveDisslip"} checked={checkedField["receiveDisslip"]} onChange={(e) => onConsentChange("receiveDisslip", e.target.checked)} />}
                                        />
                                    </FormControl>
                                </TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell style={{ background: "#F4F4F4"  }}>{`DP Account Statement`}</TableCell>
                                <TableCell style={{ background: "#D8D8D8", width: "200px", textAlign: "center" }}>{`As per SEBI Regulations`}</TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell style={{ background: "#FFF"  }}>{`CAS Flag`}</TableCell>
                                    <TableCell style={{ background: "#F4F4F4" , width: "200px", textAlign: "center" }}>
                                        <FormControl>
                                            <FormControlLabel style={{margin:0}} control={<Checkbox name={"casFlag"} id={"casFlag"} checked={checkedField["casFlag"]} onChange={(e) => onConsentChange("casFlag", e.target.checked)} />}
                                            />
                                        </FormControl>
                                    </TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell style={{ background: "#F4F4F4"  }}>{`CAS Mode`}</TableCell>
                                <TableCell style={{ background: "#D8D8D8", width: "200px", textAlign: "center" }}>{`eCAS`}</TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell style={{ background: "#FFF"  }}>{`Preferred Depository`}</TableCell>
                                <TableCell style={{ background: "#F4F4F4", width: "200px", textAlign: "center" }}>{`CDSL`}</TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell style={{ background: "#F4F4F4"  }}>{`Details of any action / proceedings initiated / pending / taken by SEBI / Stock exchange / any other authority against the applicant / constituent or its Partners / promoters / whole time directors /authorized persons in charge of dealing in securities during the last 3 years`}</TableCell>
                                <TableCell style={{ background: "#D8D8D8" , width: "200px", textAlign: "center" }}>
                                    <FormControl>
                                        <FormControlLabel style={{margin:0}} control={<Checkbox name={"pastAction"} id={"pastAction"} checked={checkedField["pastAction"]} onChange={(e) => onConsentChange("pastAction", e.target.checked)} />}
                                        />
                                    </FormControl>
                                </TableCell>
                            </TableRow>
                            {(checkedField["pastAction"]) &&
                                <TableRow>
                                    <FormControl fullWidth >
                                        <TextField id="pastActionReason" label="Details of action" variant="outlined" InputLabelProps={{ shrink: true }} inputProps={{maxLength: 100,}} value={checkedField["pastActionReason"]} onChange={(e) => {
                                                if (e.currentTarget.value.match(/^[0-9a-z ]+$/)){
                                                    onConsentChange("pastActionReason", e.currentTarget.value)
                                                }
                                            }}/>
                                    </FormControl>
                                </TableRow>
                            }
                            <TableRow>
                                <TableCell style={{ background: "#FFF"  }}>{`Client Authorisation to maintain Running Account`}</TableCell>
                                <TableCell style={{ background: "#F4F4F4", width: "200px", textAlign: "center" }}>
                                    
                                <Select
                                    id="authRunningAccount"
                                    name="authRunningAccount"
                                    value={checkedField["authRunningAccount"]}
                                    onChange={(e)=>{onConsentChange("authRunningAccount", e?.target?.value)}}
                                    size="small"
                                    input={
                                        <OutlinedInput
                                            notched
                                            label={"Running Authorization"}
                                        />
                                    }
                                >
                                    <MenuItem value=""></MenuItem>
                                    <MenuItem value={"Quarterly"}>{"Quarterly"}</MenuItem>
                                    <MenuItem value={"Monthly"}>{"Monthly"}</MenuItem>
                                </Select>
                                </TableCell>
                            </TableRow>
                            </TableBody>
                        </Table>
                    </DialogContent>   
                        <DialogActions style={{display: "-webkit-box"}}>
                            <Grid container>
                                <Grid item xs={11}>
                                <Typography variant={"body1"} style={{ marginTop: "5px", color: "#858585" }} >
                                    <span style={{ fontWeight: "600" }}>Note:To register for Easi please visit website <Link target='_blank' href="https://www.cdslindia.com">www.cdslindia.com</Link>, where BO can view ISIN balances, transactions & portfolio online.</span>
                                </Typography>
                                </Grid>
                                <Grid item xs={1}>
                                    <Button variant="contained" color="primary" disabled={isConsentSatisfied} onClick={handleConsentClose}>
                                        {localeText?.AddressOk}
                                    </Button>
                                </Grid>
                            </Grid>
                        </DialogActions> 
                </Popup>
            }
            {
        <Popup
          open={mitcConsentOpen}
          maxWidth={"lg"}
        >
          <PopupTitle dontShowCloseIcon customCSS={{ textAlign: "center" }}>{localeText?.AddressMITC}</PopupTitle>
          <DialogContent>
            <Grid>
              <List sx={{ listStyle: "numnber", pl: 4 }}>
                {
                  MITCContentData?.map((item, i) => (
                    <ListItem sx={{ display: "list-item"}}>
                      <ListItemText primary={item?.instruction} />
                    </ListItem>
                  ))
                }
              </List>
            </Grid>
          </DialogContent>
          <DialogActions style={{ display: "-webkit-box" }}>
                <Button variant="contained" color="primary" onClick={handleMitcConsentClose} style={{ float: 'right'}}>
                    {localeText?.AddressOk}
                </Button>
          </DialogActions>
        </Popup>
      }
            {<Popup
                open={aINxDocumentFailedPopup}
                maxWidth={"lg"}
            >
                <PopupTitle dontShowCloseIcon customCSS={{ textAlign: "center" }}>{localeText?.AddressAINxFailedMessage}</PopupTitle>
                <DialogContent>
                    <Grid>
                        <h3>Kindly contact KYC Team <a href="mailto: kychelpdesk@tradebulls.in"
                            title=" kychelpdesk@tradebulls.in">(kychelpdesk@tradebulls.in)</a> or
                            Enterprise Support Team <a href="mailto:enterprise.support@tradebulls.in"
                                title="enterprise.support@tradebulls.in">(enterprise.support@tradebulls.in)</a>.</h3>
                    </Grid>
                </DialogContent>
                <DialogActions style={{ display: "-webkit-box" }}>
                    <Button variant="contained" color="primary" onClick={() => { setAINxDocumentFailedPopup(false) }} style={{ float: 'right' }}>
                        {localeText?.AddressOk}
                    </Button>
                </DialogActions>
            </Popup>}
      {
        <Popup
          open={ddpiConsentOpen}
          maxWidth={"lg"}
        >
          <PopupTitle onClose={handleDdpiConsentClose} dontShowCloseIcon customCSS={{ textAlign: "center" }}>{localeText?.AddressDDPI}</PopupTitle>
          <DialogContent>
            <Grid padding={'0px 30px 1px 30px'}>
            <Grid my={1} sx={{display:'flex', justifyContent:'center', alignItems:'center', paddingBottom:'10px'}}>
                <Typography variant='p'>{localeText.consentDDPITitle}</Typography>
                </Grid>
                <Grid my={1} sx={{display:'flex', justifyContent:'center', alignItems:'center'}}>
                <Typography variant='p'>{localeText.consentDDPIDesc}</Typography>
                </Grid>
                <Grid padding={'0px 30px 0px 15px'}>
               <Table>
                            <TableHead>
                                <TableCell style ={{background:"#24B7CC", color: "white"}}>Consent Tearms</TableCell>
                                <TableCell style ={{background:"#24B7CC",borderLeft:"2px solid rgb(216 216 216)", color: "white"}}>Yes/ No</TableCell>
                            </TableHead>
                            <TableBody>
                            <TableRow>
                                <TableCell style={{ background: "#F4F4F4"  }}>{localeText?.consentDDPI1}</TableCell>
                                    <TableCell style={{ background: "#D8D8D8" , width: "200px", textAlign: "center" }}>
                                        <FormControl>
                                            <FormControlLabel style={{margin:0}} control={<Checkbox name={"transferOfSecurities"} id={"transferOfSecurities"} checked={isDdpiCheckedField["transferOfSecurities"]} onChange={(e) => onDdpiConsentChange("transferOfSecurities", e.target.checked)} />}
                                            />
                                        </FormControl>
                                    </TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell style={{ background: "#FFF"  }}>{localeText?.consentDDPI2}</TableCell>
                                    <TableCell style={{ background: "#F4F4F4" , width: "200px", textAlign: "center" }}>
                                        <FormControl>
                                            <FormControlLabel style={{margin:0}} control={<Checkbox name={"pledgingRepledgingOfSecurities"} id={"pledgingRepledgingOfSecurities"} checked={isDdpiCheckedField["pledgingRepledgingOfSecurities"]} onChange={(e) => onDdpiConsentChange("pledgingRepledgingOfSecurities", e.target.checked)} />}
                                            />
                                        </FormControl>
                                    </TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell style={{ background: "#F4F4F4"  }}>{localeText?.consentDDPI3}</TableCell>
                                    <TableCell style={{ background: "#D8D8D8" , width: "200px", textAlign: "center" }}>
                                        <FormControl>
                                            <FormControlLabel style={{margin:0}} control={<Checkbox name={"mutualFundTransactions"} id={"mutualFundTransactions"} checked={isDdpiCheckedField["mutualFundTransactions"]} onChange={(e) => onDdpiConsentChange("mutualFundTransactions", e.target.checked)} />}
                                            />
                                        </FormControl>
                                    </TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell style={{ background: "#FFF"  }}>{localeText?.consentDDPI4}</TableCell>
                                    <TableCell style={{ background: "#F4F4F4" , width: "200px", textAlign: "center" }}>
                                        <FormControl>
                                            <FormControlLabel style={{margin:0}} control={<Checkbox name={"tenderingSharesInOpenOffers"} id={"tenderingSharesInOpenOffers"} checked={isDdpiCheckedField["tenderingSharesInOpenOffers"]} onChange={(e) => onDdpiConsentChange("tenderingSharesInOpenOffers", e.target.checked)} />}
                                            />
                                        </FormControl>
                                    </TableCell>
                            </TableRow>
                            </TableBody>
                        </Table>
              </Grid>
            </Grid>
          </DialogContent>
          <DialogActions style={{ display: "-webkit-box" }}>
                <Button variant="contained" color="primary" disabled={isDDPIConsentSatisfied} onClick={handleDdpiConsentClose} style={{ float: 'right'}}>
                    {localeText?.AddressOk}
                </Button>
          </DialogActions>
        </Popup>
      }
      {
        <Popup
          open={mtfConsentOpen}
          maxWidth={"lg"}
        >
          <PopupTitle dontShowCloseIcon customCSS={{ textAlign: "center" }}>{"Rights & obligations of stock brokers & clients for Margin Trading Facility (MTF)"}</PopupTitle>
          <DialogContent>
            <Grid>
                <Grid my={1}>
                <Typography variant='p' sx={{fontWeight:'bold'}}>{localeText.consentForMarginTrading}</Typography>
                </Grid>
              <List sx={{ listStyle: "numnber", pl: 4 }}>
                {
                  MTFConsentDataForClientRights?.map((item, i) => (
                    <ListItem sx={{ display: "list-item"}}>
                      <ListItemText primary={item?.instruction} />
                    </ListItem>
                  ))
                }
              </List>
              <Grid my={1}>
                <Typography variant='p' sx={{fontWeight:'bold'}}>{localeText.consentForClientRights}</Typography>
                </Grid>
              <List sx={{ listStyle: "numnber", pl: 4 }}>
                {
                  MTFConsentDataForClient?.map((item, i) => (
                    <ListItem sx={{ display: "list-item"}}>
                      <ListItemText primary={item?.instruction} />
                    </ListItem>
                  ))
                }
              </List>
              <Grid my={1}>
                <Typography variant='p' sx={{fontWeight:'bold'}}>{localeText.consentForClientObligationsTitle}</Typography>
                </Grid>
              <List sx={{ listStyle: "numnber", pl: 4 }}>
                {
                  MTFConsentDataForClientObligations?.map((item, i) => (
                    <ListItem sx={{ display: "list-item"}}>
                      <ListItemText primary={item?.instruction} />
                    </ListItem>
                  ))
                }
              </List>
              <Grid my={1}>
                <Typography variant='p' sx={{fontWeight:'bold'}}>{localeText.consentForStockBrokerRightsTitle}</Typography>
                </Grid>
              <List sx={{ listStyle: "numnber", pl: 4 }}>
                {
                  MTFConsentForStockBrokerRights?.map((item, i) => (
                    <ListItem sx={{ display: "list-item"}}>
                      <ListItemText primary={item?.instruction} />
                    </ListItem>
                  ))
                }
              </List>
              <Grid my={1}>
                <Typography variant='p' sx={{fontWeight:'bold'}}>{localeText.consentForStockBrokerObligationsTitle}</Typography>
                </Grid>
              <List sx={{ listStyle: "numnber", pl: 4 }}>
                {
                  MTFConsentForStockBrokerObligations?.map((item, i) => (
                    <ListItem sx={{ display: "list-item"}}>
                      <ListItemText primary={item?.instruction} />
                    </ListItem>
                  ))
                }
              </List>
              <Grid my={1}>
                <Typography variant='p' sx={{fontWeight:'bold'}}>{localeText.consentForTerminationOfRelationTitle}</Typography>
                </Grid>
              <List sx={{ listStyle: "numnber", pl: 4 }}>
                {
                  MTFConsentForTerminationOfRelation?.map((item, i) => (
                    <ListItem sx={{ display: "list-item"}}>
                      <ListItemText primary={item?.instruction} />
                    </ListItem>
                  ))
                }
              </List>
              <Grid my={1}>
                <Typography variant='p' sx={{fontWeight:'bold'}}>{localeText.consentForMarginTradingFacility}</Typography>
                </Grid>
              <List sx={{ listStyle: "numnber", pl: 4 }}>
              {MTFConsentMarginTradingQuestions.map((item, i) => (
                <ListItem key={i} sx={{ display: "list-item" }}>
                <ListItemText>
                <Typography variant='p' sx={{fontWeight:'bold'}}>{item.instruction}</Typography>
                </ListItemText>
                {Array.isArray(MTFConsentForTermsofTBAnswer[i].instruction) ? (
                    MTFConsentForTermsofTBAnswer[i].instruction.map((answerItem, j) => (
                    <ul style={{ color: '#24B7CC !important', paddingRight: '15px' }}>
                            <li key={j}> {answerItem}</li>
                    </ul>
                    ))
                ) : (
                    <ListItemText primary={MTFConsentForTermsofTBAnswer[i].instruction} />
                )}
                </ListItem>))}
              </List>             
            </Grid>
          </DialogContent>
          <DialogActions style={{ display: "-webkit-box" }}>
            <Button variant="contained" color="primary" onClick={handleMtfConsentClose} style={{ float: 'right'}}>
                    {localeText?.AddressOk}
            </Button>                   
          </DialogActions>
        </Popup>
      }

            {
                responseStatus && responseStatus.message && <Snackbar
                    anchorOrigin={{
                        vertical: 'top',
                        horizontal: 'center',
                    }}
                    open={snackBarOpen}
                    autoHideDuration={5000}
                    onClose={handleSnackBarClose}
                >
                    <MySnackbarContentWrapper
                        onClose={handleSnackBarClose}
                        variant={responseStatus.type}
                        message={responseStatus.message}
                    />
                </Snackbar>
            }
        </>
    );
}

export default AddressDetails;